import {Injectable} from '@angular/core';
import {ContextBarComponent} from './context-bar.component';
import ArtistModel from '../../../model/artist.model';
import CooperationModel from '../../../model/cooperation.model';
import CustomerModel from '../../../model/customer.model';
import {BehaviorSubject} from "rxjs";

@Injectable()
export default class ContextBarService {
  private cooperationSubject = new BehaviorSubject<CooperationModel>(null);
  public cooperation$ = this.cooperationSubject.asObservable();

  private artistSubject = new BehaviorSubject<ArtistModel>(null);
  public artist$ = this.artistSubject.asObservable();

  private customerSubject = new BehaviorSubject<CustomerModel>(null);
  public customer$ = this.customerSubject.asObservable();


  public setCooperation(coop: CooperationModel) {
    this.cooperationSubject.next(coop);
  }

  public getCooperationSnapshot() {
    return this.cooperationSubject.getValue();
  }

  public setCustomer(customer: CustomerModel) {
    this.customerSubject.next(customer);
  }

  public setArtist(artist: ArtistModel) {
    this.artistSubject.next(artist);
  }

  public getCustomerSnapshot() {
    return this.customerSubject.getValue();
  }
  public getArtistSnapshot() {
    return this.artistSubject.getValue();
  }

  public resetContext() {
    this.cooperationSubject.next(null);
    this.customerSubject.next(null);
    this.artistSubject.next(null);
  }
}
